<!-- EACH ITEM -->
<div class="row cart-item-cart" [ngClass]="{ 'light-disabled-border-color': !bonus, 'accent-border-color bonus': bonus }">
  <!-- PHOTO AND NAME -->
  <div class="col-12 col-md-8">
    <div class="row">
      <div class="col-3">
        <!-- PHOTO -->
        <div class="cart-item-image">
          <a class="item-name" [routerLink]="item.route">
            <img [src]="item.photo.thumbnail_url" class="light-disabled-border-color hover-accent-border-color">
          </a>
        </div>
      </div>

      <div class="col-7">
        <!-- PREORDER DATE -->
        <div *ngIf="item.preorderDate">
          <div class="warn-color item-artist-name">
            PRE-ORDER
          </div>
          <div class="warn-color" *ngIf="item.isPhysical">Ships on or before {{ item.preorderDate | date:'longDate' }}</div>
          <div class="warn-color" *ngIf="!item.isPhysical">Available  {{ item.preorderDate | date:'longDate' }}</div>
        </div>

        <!-- NAME -->
        <div class="item-artist-name">{{ item.artistName }}</div>
        <div class="item-name">{{ item.name }}</div>

        <!-- BUNDLE ITEMS -->
        <div *ngIf="item.subnames.length">
          <ul>
            <li *ngFor="let subName of item.subnames">
              {{ subName }}
            </li>
          </ul>
        </div>

        <!-- FORMAT -->
        <div class="item-format" *ngIf="!item.subnames.length">{{ item.format }}</div>

        <!-- SALE NAME & URL-->
        <div class="item-sale-name" *ngIf="item.saleName">
          <a *ngIf="!!item.saleUrl" [routerLink]="['/store', item.saleUrl]">Shop All: {{ item.saleName }}</a>
          <span *ngIf="!item.saleUrl" class="warn-color">{{ item.saleName }}</span>
        </div>
      </div>
      <div class="col-2 remove-button warn-color-link">
        <!-- MOBILE REMOVE -->
        <div *ngIf="!bonus" class="col-md-1 d-md-none">
          <span (click)="!loading && remove(item)"><i class="fa fa-times"></i></span>
        </div>
      </div>
    </div>
  </div>

  <!-- MOBILE QUANTITY AND PRICE -->
  <div class="col-6 d-md-none">
    <input
      *ngIf="item.id"
      class="form-control qty-input"
      type="number"
      step="1"
      min="1"
      max="100"
      [disabled]="loading"
      (change)="onQuantityChange($event, item)"
      [value]="item.quantity"
    />
  </div>

  <div class="col-6 d-md-none">
    <div class="align-right" [ngClass]="{ 'strikethrough dark-disabled-color': hasSale() }">
      {{ item.originalPrice * item.quantity | currency }}
    </div>
    <div class="align-right" *ngIf="item.price != item.originalPrice">
      {{ item.price * item.quantity | currency }}
    </div>
  </div>

  <!-- DESKTOP QUANTITY -->
  <div class="col-md-2 d-none d-md-block">
    <input
      *ngIf="item.id"
      class="form-control qty-input"
      type="number"
      step="1"
      min="1"
      max="100"
      [disabled]="loading"
      (change)="onQuantityChange($event, item)"
      [value]="item.quantity"
    />
  </div>

  <!-- DESKTOP PRICE -->
  <div class="col-md-1 d-none d-md-block price">
    <div [ngClass]="{ 'strikethrough dark-disabled-color': hasSale() }">
      {{ item.originalPrice * item.quantity | currency }}
    </div>
    <div *ngIf="item.price != item.originalPrice">
      {{ item.price * item.quantity | currency }}
    </div>
  </div>

  <!-- DESKTOP REMOVE -->
  <div *ngIf="!bonus" class="col-md-1 d-none d-md-flex remove-button warn-color-link">
    <span (click)="!loading && remove(item)"><i class="fa fa-times"></i></span>
  </div>

  <div class="col-11 error-message warn-color">
    {{ errorMessage }}
  </div>
</div>
